var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/UserClassifierGroup/UserClassifierGroup.ts";
import "core-js/modules/es.function.name.js";
import * as t from 'io-ts';
import { merge } from 'effector';
import * as Sentry from '@sentry/browser';
import { ApiCallService } from '@gmini/api-call-service';
import { BimReference } from '../../BimReference';
import { Version } from '../../Version';
import { Id } from '../../Id';
import { createPredicate } from '../../createPredicate';
import { ApiDomain } from '../../domain';
import { errorNameMap } from '../../logApiError';
import { DynamicGroup } from '../DynamicGroup/DynamicGroup';
import { Filter } from '../Filter';
import { FlatDependency } from '../../FlatListDependencies';
import { UserClassifierGroupSource } from './UserClassifierGroupSource';
export var UserClassifierGroup;

(function (_UserClassifierGroup) {
  var domain = ApiDomain.domain('UserClassifierGroup', {
    name: "domain",
    sid: "cs9qch"
  });
  var io = _UserClassifierGroup.io = t.recursion('UserClassifierGroup', function () {
    return t.union([WithGroups.io, WithElements.io, Empty.io]);
  });

  var is = _UserClassifierGroup.is = function (entity) {
    return WithGroups.is(entity) || WithElements.is(entity) || Empty.is(entity);
  };

  var Populated;

  (function (_Populated) {
    var io = _Populated.io = t.recursion('UserClassifierGroupPopulated', function () {
      return t.union([WithGroups.Populated.io, WithElements.Populated.io, Empty.io]);
    });

    var is = _Populated.is = function (entity) {
      return WithGroups.Populated.is(entity) || WithElements.Populated.is(entity) || Empty.is(entity);
    };
  })(Populated || (Populated = _UserClassifierGroup.Populated || (_UserClassifierGroup.Populated = {})));

  var WithGroups;

  (function (_WithGroups) {
    var io = _WithGroups.io = t.type({
      type: t.literal('UserClassifierGroupWithGroups'),
      id: Id,
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      parentGroupId: t.union([t["null"], Id]),
      source: t.union([t["null"], UserClassifierGroupSource]),
      name: t.string,
      total: t.number,
      dynamicGroup: t.union([DynamicGroup.io, t["null"]]),
      filterCondition: t.union([Filter.Data, t["null"]])
    }, 'UserClassifierGroupWithGroups');
    var is = _WithGroups.is = createPredicate('UserClassifierGroupWithGroups');
    var Populated;

    (function (_Populated2) {
      var io = _Populated2.io = t.type({
        type: t.literal('UserClassifierGroupWithGroupsPopulated'),
        id: Id,
        parentClassifierId: Id,
        parentClassifierVersion: Version,
        parentGroupId: t.union([t["null"], Id]),
        source: t.union([t["null"], UserClassifierGroupSource]),
        name: t.string,
        total: t.number,
        children: t.recursion('DynamicGroup', function () {
          return t.readonlyArray(UserClassifierGroup.io);
        }),
        offset: t.number,
        dynamicGroup: t.union([DynamicGroup.io, t["null"]]),
        filterCondition: t.union([Filter.Data, t["null"]])
      }, 'UserClassifierGroupWithGroupsPopulated');
      var is = _Populated2.is = createPredicate('UserClassifierGroupWithGroupsPopulated');
    })(Populated || (Populated = _WithGroups.Populated || (_WithGroups.Populated = {})));
  })(WithGroups || (WithGroups = _UserClassifierGroup.WithGroups || (_UserClassifierGroup.WithGroups = {})));

  var WithElements;

  (function (_WithElements) {
    var io = _WithElements.io = t.type({
      type: t.literal('UserClassifierGroupWithElements'),
      id: Id,
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      parentGroupId: t.union([t["null"], Id]),
      source: t.union([t["null"], UserClassifierGroupSource]),
      name: t.string,
      total: t.number,
      dynamicGroup: t.union([DynamicGroup.io, t["null"]]),
      filterCondition: t.union([Filter.Data, t["null"]])
    }, 'UserClassifierGroupWithElements');
    var is = _WithElements.is = createPredicate('UserClassifierGroupWithElements');
    var Populated;

    (function (_Populated3) {
      var io = _Populated3.io = t.type({
        type: t.literal('UserClassifierGroupWithElementsPopulated'),
        id: Id,
        parentClassifierId: Id,
        parentClassifierVersion: Version,
        parentGroupId: t.union([t["null"], Id]),
        source: t.union([t["null"], UserClassifierGroupSource]),
        name: t.string,
        total: t.number,
        children: t.recursion('children', function () {
          return t.readonlyArray(BimReference.io);
        }),
        offset: t.number,
        dynamicGroup: t.union([DynamicGroup.io, t["null"]]),
        filterCondition: t.union([Filter.Data, t["null"]])
      }, 'UserClassifierGroupWithElementsPopulated');
      var is = _Populated3.is = createPredicate('UserClassifierGroupWithElementsPopulated');
    })(Populated || (Populated = _WithElements.Populated || (_WithElements.Populated = {})));
  })(WithElements || (WithElements = _UserClassifierGroup.WithElements || (_UserClassifierGroup.WithElements = {})));

  var Empty;

  (function (_Empty) {
    var io = _Empty.io = t.type({
      type: t.literal('UserClassifierEmptyGroup'),
      id: Id,
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      parentGroupId: t.union([t["null"], Id]),
      source: t.union([t["null"], UserClassifierGroupSource]),
      name: t.string,
      total: t.number,
      dynamicGroup: t.union([DynamicGroup.io, t["null"]]),
      filterCondition: t.union([Filter.Data, t["null"]])
    }, 'UserClassifierEmptyGroup');
    var is = _Empty.is = createPredicate('UserClassifierEmptyGroup');
  })(Empty || (Empty = _UserClassifierGroup.Empty || (_UserClassifierGroup.Empty = {})));

  var ListResponse = _UserClassifierGroup.ListResponse = t.array(io);
  var create = _UserClassifierGroup.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: Empty.io,
    getKey: ['name', 'classifierId', 'parentClassifierVersion', 'parentGroupId']
  });
  var fetch = _UserClassifierGroup.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: Populated.io,
    getKey: ['id', 'classifierId', 'parentClassifierVersion']
  });
  var rename = _UserClassifierGroup.rename = ApiCallService.create({
    name: 'rename',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'classifierId', 'parentClassifierVersion', 'name']
  });
  var move = _UserClassifierGroup.move = ApiCallService.create({
    name: 'move',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'classifierId', 'parentGroupId', 'parentClassifierVersion']
  });
  var remove = _UserClassifierGroup.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'classifierId', 'parentClassifierVersion']
  });
  var createGroupReference = _UserClassifierGroup.createGroupReference = ApiCallService.create({
    name: 'createGroupReference',
    parentDomain: domain,
    result: io,
    getKey: ['classifierId', 'parentClassifierVersion', 'parentGroupId', 'sourceGroupId', 'sourceClassifierId', 'sourceClassifierVersion']
  });
  var Property;

  (function (_Property) {
    var domain = ApiDomain.domain('Property', {
      name: "domain",
      sid: "-rrtmfh"
    });
    var io = _Property.io = t.type({
      id: Id,
      name: t.string,
      groupName: t.string
    }, 'Property');
    var List;

    (function (_List) {
      var io = _List.io = t.array(Property.io);
      var ElementProperties;

      (function (_ElementProperties) {
        var io = _ElementProperties.io = t.type({
          elementProperties: Property.List.io
        });
      })(ElementProperties || (ElementProperties = _List.ElementProperties || (_List.ElementProperties = {})));

      var StandardSizeProperties;

      (function (_StandardSizeProperties) {
        var io = _StandardSizeProperties.io = t.type({
          standardSizeProperties: Property.List.io
        });
      })(StandardSizeProperties || (StandardSizeProperties = _List.StandardSizeProperties || (_List.StandardSizeProperties = {})));

      var fetchElementProperties = _List.fetchElementProperties = ApiCallService.create({
        name: 'fetch',
        parentDomain: domain,
        result: ElementProperties.io,
        getKey: ['classifierId', 'classifierVersion', 'groupId']
      });
      var fetchStandardSizeProperties = _List.fetchStandardSizeProperties = ApiCallService.create({
        name: 'fetch',
        parentDomain: domain,
        result: StandardSizeProperties.io,
        getKey: ['classifierId', 'classifierVersion', 'groupId']
      });
      merge([fetchStandardSizeProperties.fail, fetchElementProperties.fail], {
        sid: "-c7nn20"
      }).watch(function (fail) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (fail.error.name !== 'AbortError') {
          Sentry.captureEvent({
            message: errorNameMap[fail.error.status],
            extra: fail
          });
        }
      });
      var Fetch = _List.Fetch = ApiCallService.create({
        name: 'GetPropertyList',
        parentDomain: domain,
        result: ElementProperties.io,
        getKey: function getKey() {
          return '0';
        }
      });
    })(List || (List = _Property.List || (_Property.List = {})));
  })(Property || (Property = _UserClassifierGroup.Property || (_UserClassifierGroup.Property = {})));

  var createFilter = _UserClassifierGroup.createFilter = ApiCallService.create({
    name: 'createFilter',
    parentDomain: domain,
    result: UserClassifierGroup.io,
    getKey: ['classifierId', 'classifierVersion', 'groupId']
  });
  var updateFilter = _UserClassifierGroup.updateFilter = ApiCallService.create({
    name: 'updateFilter',
    parentDomain: domain,
    result: UserClassifierGroup.io,
    getKey: ['classifierId', 'classifierVersion', 'groupId']
  });
  var removeFilter = _UserClassifierGroup.removeFilter = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: UserClassifierGroup.io,
    getKey: ['classifierId', 'classifierVersion', 'groupId']
  });
  var GroupCopyingRes = _UserClassifierGroup.GroupCopyingRes = t.recursion('GroupCopyingRes', function () {
    return t.type({
      classifierId: Id,
      classifierVersion: Version,
      userClassifierGroupFlats: t.array(t.intersection([t.type({
        parentId: t.union([t.number, t["null"]]),
        parentType: t.union([FlatDependency.type, t["null"]])
      }), FlatDependency.io]))
    });
  });
  var groupCopying = _UserClassifierGroup.groupCopying = ApiCallService.create({
    name: 'groupCopying',
    parentDomain: domain,
    result: GroupCopyingRes,
    getKey: ['classifierId', 'classifierVersion', 'sourceGroupId', 'parentGroupId']
  });
})(UserClassifierGroup || (UserClassifierGroup = {}));